import React from "react";
import { Link } from "react-router-dom";

export default function Module_3({ data }) {
    return (
        <>
            <div className="row py-4 module-3">
                <div className="col-md-7">
                    <h2 className="text-muted">
                        An extensive product portfolio backed by a 100%
                        satisfaction guarantee
                    </h2>
                    <p>
                        At DSSL, we stand by our products and we back them with
                        sound customer support and some of the best warranties
                        in the business. Our robust line of LED products made or
                        assembled in America complies with Buy American Act and
                        American Reinvestment & Recovery Act requirements.
                    </p>
                </div>
                <div className="col-md-1">
                    <div className="featurette-vertical-divider"></div>
                </div>
                <div className="col-md-3 d-flex align-items-center justify-content-center">
                    <ul className="list-unstyled d-flex flex-column justify-content-around h-100">
                        {data.map((category) => {
                            return (
                                <li key={category.id}>
                                    <Link
                                        to={`/products/category/${category.attributes.name}`}
                                    >
                                        {category.attributes.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </>
    );
}
